/**
 * Flat arcade palette. Every brick colour ships with a light bevel and a dark
 * bevel so the renderer can fake CRT-era chunky shading without gradients.
 */

const shade = (hex, amount) => {
  const n = parseInt(hex.slice(1), 16);
  const clamp = (v) => Math.max(0, Math.min(255, Math.round(v)));
  const r = clamp(((n >> 16) & 255) + amount);
  const g = clamp(((n >> 8) & 255) + amount);
  const b = clamp((n & 255) + amount);
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
};

const brick = (hex) => ({ base: hex, light: shade(hex, 58), dark: shade(hex, -62) });

export const BRICK_COLORS = Object.freeze({
  w: brick('#d8dde6'),
  o: brick('#e08430'),
  c: brick('#3fbcd4'),
  g: brick('#4fb15c'),
  r: brick('#d1453f'),
  b: brick('#4463c9'),
  m: brick('#b34fb8'),
  y: brick('#dcbb37'),
  S: brick('#8b939f'),
  G: brick('#c9a13c'),
});

export const UI = Object.freeze({
  void: '#0b0d11',
  floor: '#111419',
  texture: '#171b22',
  frameOuter: '#2a2f38',
  frameInner: '#3c434f',
  frameEdge: '#181c22',
  rivet: '#565f6d',
  ink: '#f2f4f8',
  inkDim: '#8d97a6',
  accent: '#f0803c',
  accentAlt: '#46c8d8',
  danger: '#e0574f',
  good: '#5fc46a',
  ball: '#f6f8fc',
  ballTrail: '#7f8899',
});

export const PADDLE_COLORS = Object.freeze({
  shell: '#ced6e2',
  shellDark: '#7b8494',
  core: '#20252d',
  cap: '#3f7ad6',
  capLaser: '#d9463f',
  capCatch: '#4fb15c',
  seam: '#59616f',
});

/** Per-round backdrop tints, cycled by round index. */
export const BACKDROPS = Object.freeze([
  { base: '#0e1116', grid: '#161b23', accent: '#1d2531' },
  { base: '#0f1014', grid: '#1a1720', accent: '#2a1f2e' },
  { base: '#0c1114', grid: '#141e21', accent: '#1b2c2f' },
  { base: '#101015', grid: '#1c1a22', accent: '#2b2536' },
  { base: '#120f10', grid: '#20191a', accent: '#301f21' },
  { base: '#0d1218', grid: '#151f28', accent: '#1c2b38' },
]);

export const CAPSULE_COLORS = Object.freeze({
  L: '#d9463f',
  E: '#4463c9',
  C: '#4fb15c',
  S: '#e08430',
  D: '#3fbcd4',
  B: '#b34fb8',
  P: '#b9c0cc',
  R: '#7a3038',
});
